import React from 'react';

import Archive from '@/components/ui-bridge/icons/Archive';

let SectionArquivadas = props => <Archive {...props} />;
SectionArquivadas = React.memo(SectionArquivadas);
SectionArquivadas.displayName = 'SectionArquivadas';

export default SectionArquivadas;
